<script>
import axios from 'axios';
import router from '@/router';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import progressContainer from './progressContainer';
import { required, sameAs, email } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer, progressContainer },
	data() {
		return {
			userData: JSON.parse(localStorage.getItem('web_user')),
			backToOverview: false,
			typeSubmit: false,
			addReferencesForm: {
				user_type_id: null,
				user_type: 'mentor',
				name: null,
				telephone: null,
				email: null,
				confirm_email: null,
				relationship: null,
				status: '1',
			},
		};
	},
	validations: {
		addReferencesForm: {
			name: { required },
			telephone: { required },
			email: { required, email },
			confirm_email: { required, sameAsEmail: sameAs('email') },
			relationship: { required },
		},
	},
	mounted() {
		this.getReferences();
		this.getSubmitFormStats();
	},
	methods: {
		skipToReview() {
			router.push({ name: 'review-application' });
		},

		addReferences() {
			this.typeSubmit = true;
			this.$v.$touch();
			if (this.$v.$invalid) {
				return;
			}

			let userData = JSON.parse(localStorage.getItem('web_user'));
			if (!userData || !userData.token) {
				return;
			}

			let config = { headers: { Authorization: 'Bearer ' + userData.token } };
			this.addReferencesForm.user_type_id = parseInt(userData['user_type_id']);
			axios
				.post('user/references', this.addReferencesForm, config)
				.then((res) => {
					this.typeSubmit = false;
					if (res.status == 200) {
						if (this.userData.user_type_id === 4) {
							if (this.userData.is_mentor) {
								router.push({ name: 'opportunities' });
							} else {
								// if volunteer
								router.push({ name: 'employment' });
							}
						} else {
							// if mentor
							router.push({ name: 'review-application' });
						}
					}
				})
				.catch((err) => {
					this.typeSubmit = false;
					console.log(err?.response?.data?.error?.message);
				});
		},
		// Getting Current User References
		getReferences() {
			let userData = JSON.parse(localStorage.getItem('web_user'));
			if (!userData || !userData.token) {
				return;
			}

			let config = { headers: { Authorization: 'Bearer ' + userData.token } };
			axios
				.get('user/references/' + userData['id'] + '?user_type_id=' + parseInt(userData['user_type_id']), config)
				.then((res) => {
					if (res.data.response) {
						this.addReferencesForm = { ...this.addReferencesForm, ...res.data.response };
					}
				})
				.catch((err) => {
					console.log(err?.response?.data?.error?.message);
				});
		},

		// Getting Current User Forms States
		getSubmitFormStats() {
			let formCompleted = true;
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData['token'] },
			};
			if (userData.token) {
				axios
					.get('user/registration/submitted-forms?user_type_id=' + parseInt(userData['user_type_id']), config)
					.then((res) => {
						// Mentor
						if (userData['user_type_id'] == 3) {
							if (res.data.response.additional_details === false) {
								formCompleted = false;
							}
							if (res.data.response.background === false) {
								formCompleted = false;
							}
							if (res.data.response.faith === false) {
								formCompleted = false;
							}
							if (res.data.response.personal_info === false) {
								formCompleted = false;
							}
							if (res.data.response.question === false) {
								formCompleted = false;
							}
							if (res.data.response.reference === false) {
								formCompleted = false;
							}
						} else {
							if (userData.is_mentor) {
								// Mentor/Volunteer
								if (res.data.response.additional_details === false) {
									formCompleted = false;
								}
								if (res.data.response.background === false) {
									formCompleted = false;
								}
								if (res.data.response.faith === false) {
									formCompleted = false;
								}
								if (res.data.response.personal_info === false) {
									formCompleted = false;
								}
								if (res.data.response.question === false) {
									formCompleted = false;
								}
								if (res.data.response.reference === false) {
									formCompleted = false;
								}
								if (res.data.response.opportunity === false) {
									formCompleted = false;
								}
							} else {
								// Volunteer
								if (res.data.response.additional_details === false) {
									formCompleted = false;
								}
								if (res.data.response.faith === false) {
									formCompleted = false;
								}
								if (res.data.response.opportunity === false) {
									formCompleted = false;
								}
								if (res.data.response.personal_info === false) {
									formCompleted = false;
								}
								if (res.data.response.question === false) {
									formCompleted = false;
								}
							}
						}

						if (!formCompleted) {
							this.backToOverview = false;
						} else {
							this.backToOverview = true;
						}
					})
					.catch((err) => {
						console.log(err?.response?.data?.error?.message);
					});
			}
		},

		faith() {
			router.push({ name: 'faith' });
		},
		// back to additional details
		additionalDetails() {
			router.push({ name: 'additional-details' });
		},

		contact() {
			router.push({ name: 'contact' });
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row mx-0">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title" v-if="userData.is_mentor">Mentor / Volunteer Details</h3>
						<h3 class="title" v-else>{{ userData['user_type_id'] === 3 ? 'Mentor' : 'Volunteer' }} Application</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a @click="contact" href="javascript:">Contact Us</a></p>
					</div>
				</div>
			</div>
		</div>
		<div id="create-account">
			<div class="container">
				<div class="row mx-0 justify-content-center">
					<div class="col-12">
						<progressContainer :userData="userData" :active="'references'" />
					</div>
				</div>
				<form @submit.prevent="addReferences" class="custom-form">
					<div class="row mx-0">
						<div class="col-12 mb-5">
							<h3 class="main-title">Character Reference</h3>
						</div>
						<div class="col-12 mb-5">
							<span class="font-size-16 d-inline-block mb-2">
								All mentors working with our clients must be able to model a mature Christian lifestyle. We are especially interested in your ability to maintain professional boundaries with our clients. Because of the nature of our program, and the large amount of responsibility given to our
								mentors, we are requesting that you provide the name of someone that can serve as a character reference on your behalf. Whether it is a pastor, friend, or colleague, please select someone that has known you long enough to speak to your character and abilities.
								<b>Your character reference may NOT be someone who is related to you or to whom you are dating, engaged, or married.</b>
								This character reference is confidential; MnTC will not be able to share the results with you.
							</span>
						</div>
					</div>

					<div class="row mx-0">
						<div class="col-12">
							<h3 class="font-size-20">Reference</h3>
						</div>
						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-model="addReferencesForm.name" type="text" placeholder="Enter first and last name *" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.addReferencesForm.name.$error }" />
								<div v-if="typeSubmit && $v.addReferencesForm.name.$error" class="invalid-feedback">
									<span v-if="!$v.addReferencesForm.name.required">This field is required.</span>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-mask="'###-###-####'" v-model="addReferencesForm.telephone" type="text" placeholder="Enter Telephone *" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.addReferencesForm.telephone.$error }" />
								<div v-if="typeSubmit && $v.addReferencesForm.telephone.$error" class="invalid-feedback">
									<span v-if="!$v.addReferencesForm.telephone.required">This field is required.</span>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-model="addReferencesForm.email" type="text" placeholder="Enter Email Address *" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.addReferencesForm.email.$error }" />
								<div v-if="typeSubmit && $v.addReferencesForm.email.$error" class="invalid-feedback">
									<span v-if="!$v.addReferencesForm.email.required">Email is required.</span>
									<span v-if="!$v.addReferencesForm.email.email">This must be a valid email address.</span>
								</div>
							</div>
						</div>

						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-model="addReferencesForm.confirm_email" type="text" placeholder="Confirm Email *" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.addReferencesForm.confirm_email.$error }" />
								<div v-if="typeSubmit && $v.addReferencesForm.confirm_email.$error" class="invalid-feedback">
									<span v-if="!$v.addReferencesForm.confirm_email.required">Confirmation Email is required.</span>
									<span v-if="!$v.addReferencesForm.confirm_email.sameAsEmail"><br />Email addresses must match.</span>
								</div>
							</div>
						</div>

						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-model="addReferencesForm.relationship" type="text" placeholder="Enter Relationship *" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.addReferencesForm.relationship.$error }" />
								<small class="d-inline-block ms-4 mt-2 font-size-14">How do you know this person?</small>
								<div v-if="typeSubmit && $v.addReferencesForm.relationship.$error" class="invalid-feedback">
									<span v-if="!$v.addReferencesForm.relationship.required">This field is required.</span>
								</div>
							</div>
						</div>
					</div>
					<div class="row mx-0">
						<div class="col-12"></div>
					</div>
					<div class="row mx-0">
						<div class="mb-2 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-end align-items-stretch align-items-md-start" v-if="backToOverview">
							<b-button type="button" @click="skipToReview" variant="custom">
								<i class="font-size-20 me-2 bx bxs-right-arrow-circle"></i>
								Skip To Review
							</b-button>
						</div>

						<div class="mb-4 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-if="userData['user_type_id'] === 4 && !userData.is_mentor">
							<b-button type="button" @click="faith" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Back to Faith</b-button>
							<b-button type="button" @click="addReferences" variant="custom">Employment <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
						</div>
						<div class="mb-4 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-else-if="userData['user_type_id'] === 4 && userData.is_mentor">
							<b-button type="button" @click="additionalDetails" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Interests, Skills Involvement</b-button>
							<b-button type="button" @click="addReferences" variant="custom">Opportunities <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
						</div>
						<div class="mb-4 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-else>
							<b-button type="button" @click="additionalDetails" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Interests, Skills Involvement</b-button>
							<b-button type="button" @click="addReferences" variant="custom">Review Application <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
